import Autocomplete from "@material-ui/core/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { UseAutocompleteProps } from '@material-ui/core/useAutocomplete';
import React from "react";
import { useCopyToClipboard } from "react-use";
import {BarcodesFieldFC} from "./types";
import useLimitTags from "../../PageProduct/Fields/hooks/useLimitTags";
import useAlerts from "../../../hooks/useAlerts";

const BarcodesField: BarcodesFieldFC = ({barcodes, changeValue}) => {
  const limitTags = useLimitTags();
  const handlerBlur = ({
    target: { value },
  }: React.FocusEvent<
    HTMLInputElement | HTMLTextAreaElement,
    Element
  >): void => {
    if (value.length > 0) {
      changeValue([...barcodes, value]);
    }
  };
  const [, copyToClipboard] = useCopyToClipboard();
  const message = useAlerts();
  const handlerClickBarcode: React.MouseEventHandler<HTMLDivElement> = ({
    currentTarget: { textContent },
  }) => {
    if (!textContent) {
      return;
    }
    copyToClipboard(textContent);
    message({
      message: "Штрих-код скопирован в буфер обмена",
      variant: "info",
      autoHideDuration: 5000
    });
  };
  const handlerChange:UseAutocompleteProps<string, true, false, true>['onChange'] = (e, barcodes) => {
    changeValue(Array.isArray(barcodes) ? barcodes : [barcodes]);
  };
  return (
    <Autocomplete
      multiple
      options={[]}
      freeSolo
      value={barcodes}
      limitTags={limitTags}
      size={"small"}
      onChange={handlerChange}
      ChipProps={{
        clickable: true,
        onClick: handlerClickBarcode,
        variant: "outlined",
        size: "small",
      }}
      renderInput={(props) => (
        <TextField
          {...props}
          variant={"outlined"}
          onBlur={handlerBlur}
        />
      )}
    />
  );
};

export default BarcodesField;
